import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const errorMessageTranslationsK = {
  invalidUser: "error_message_translations.invalidUser",
  objectExpired: "error_message_translations.objectExpired",
  translationMissing: "error_message_translations.translationMissing",
  publicLoginFailedLoginDisabled: "error_message_translations.publicLoginFailedLoginDisabled",
  publicLoginInvalidPassword: "error_message_translations.publicLoginInvalidPassword",
  notFound: "error_message_translations.notFound",
  invalidObject: "error_message_translations.invalidObject",
  applicationSettingMissing: "error_message_translations.applicationSettingMissing",
  fileOperationError: "error_message_translations.fileOperationError",
  duplicateObject: "error_message_translations.duplicateObject",
  mismatch: "error_message_translations.mismatch",
  requiredPropertyMissing: "error_message_translations.requiredPropertyMissing",
  idMismatch: "error_message_translations.idMismatch",
  frontEndError: "error_message_translations.frontEndError",
  unhandledException: "error_message_translations.unhandledException",
  permissionDenied: "error_message_translations.permissionDenied",
  propertyNotAllowedForNewElement: "error_message_translations.propertyNotAllowedForNewElement",
  getByIdNotFound: "error_message_translations.getByIdNotFound",
  publicLoginFailedUnknownIdentity: "error_message_translations.publicLoginFailedUnknownIdentity",
  publicLoginFailedUserNamePasswordIsInvalid: "error_message_translations.publicLoginFailedUserNamePasswordIsInvalid",
};

export const useErrorMessageTranslationsT = () => {
  const { t, i18n } = useTranslation();
  
  return useMemo(
    () => ({
      invalidUser: t(errorMessageTranslationsK.invalidUser),
      objectExpired: t(errorMessageTranslationsK.objectExpired),
      translationMissing: t(errorMessageTranslationsK.translationMissing),
      publicLoginFailedLoginDisabled: t(errorMessageTranslationsK.publicLoginFailedLoginDisabled),
      publicLoginInvalidPassword: t(errorMessageTranslationsK.publicLoginInvalidPassword),
      notFound: t(errorMessageTranslationsK.notFound),
      invalidObject: t(errorMessageTranslationsK.invalidObject),
      applicationSettingMissing: t(errorMessageTranslationsK.applicationSettingMissing),
      fileOperationError: t(errorMessageTranslationsK.fileOperationError),
      duplicateObject: t(errorMessageTranslationsK.duplicateObject),
      mismatch: t(errorMessageTranslationsK.mismatch),
      requiredPropertyMissing: t(errorMessageTranslationsK.requiredPropertyMissing),
      idMismatch: t(errorMessageTranslationsK.idMismatch),
      frontEndError: t(errorMessageTranslationsK.frontEndError),
      unhandledException: t(errorMessageTranslationsK.unhandledException),
      permissionDenied: t(errorMessageTranslationsK.permissionDenied),
      propertyNotAllowedForNewElement: t(errorMessageTranslationsK.propertyNotAllowedForNewElement),
      getByIdNotFound: t(errorMessageTranslationsK.getByIdNotFound),
      publicLoginFailedUnknownIdentity: t(errorMessageTranslationsK.publicLoginFailedUnknownIdentity),
      publicLoginFailedUserNamePasswordIsInvalid: t(errorMessageTranslationsK.publicLoginFailedUserNamePasswordIsInvalid),
    }),
    [i18n.language]
  );
};